<template>
  <article :class="className" class="card">
    <div class="dropdown__title" tabindex="0" role="button" @click="onClickToggle" @keydown.space="onClickToggle">
      <h3>{{ title }}</h3>

      <figure class="dropdown__icon">
        <SvgIcon id="arrow" />
      </figure>
    </div>

    <DropDown :is-open="isOpen" content-class="dropdown__content">
      <slot />
    </DropDown>
  </article>
</template>

<script>
export default {
  name: 'ComponentDemoDropdownBox',
  props: {
    title: { type: String, default: null },
    isOpen: { type: Boolean, default: false }
  },
  computed: {
    className() {
      return ['dropdown__item', { '-open': this.isOpen }]
    }
  },
  methods: {
    onClickToggle() {
      if (this.isOpen) return this.$emit('close')
      this.$emit('open')
    }
  }
}
</script>
